// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import { convertBetweenMandFt } from 'helpers/unitConversion'

const getTriggerFields = formValues => (dispatch, getState) => {
  const unitType = getState().bulkEdit.get('unitType')

  const [regulatoryData] = formValues.regulatory
  const [siteData] = formValues.sites

  const {
    contactId,
    latitude,
    longitude,
    siteName,
  } = siteData

  const {
    asr,
    callSign,
  } = regulatoryData

  // NOTE - elevation here is a string. we're checking to see
  // if the elevation input field has a value or not.
  const elevation = (
    // be sure that the unit type is the same for this stored value and the cached values in projectSummary paths (redux store)
    unitType !== siteData.elevationUnit
      ? castToString(convertBetweenMandFt(siteData.elevation, siteData.elevationUnit))
      : siteData.elevation
  )

  return {
    asr,
    callSign,
    contactId,
    elevation,
    latitude,
    longitude,
    siteName,
  }
}

export default getTriggerFields
